import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { reduxForm, propTypes, Field } from 'redux-form';
//
import { TextField, PasswordField, Button } from 'components';
import { ROUTES } from 'config/constants';
import { FormTile } from 'components/FormTile';
import { validate } from './validate';

@reduxForm({
  form: 'loginForm',
  validate,
})
export class LoginForm extends React.PureComponent {
  static propTypes = {
    ...propTypes,
    isFormProcessed: PropTypes.bool,
  };

  render() {
    const { handleSubmit, error, submitFailed, isFormProcessed } = this.props;

    return (
      <form
        onSubmit={handleSubmit}
        className="form-tile-with-image "
        data-testid="login-form"
      >
        <FormTile isLoaderShow={isFormProcessed} dataTestId="login-form">
          <FormTile.Header>
            <div className="form-description-logo">
              <img
                className="form-description-logo__img"
                src="/assets/images/logo/description-logo@2x.png"
                alt="Anova logo"
              />
            </div>
          </FormTile.Header>
          <FormTile.Body>
            <h2 className="mt-25">Let's get started!</h2>
            <div className="mt-1 form-fields__description">
              Or create an account if not registered yet.
            </div>
            <Field
              label="Email:"
              name="email"
              isBackgroundErrorDisplay={false}
              component={TextField}
              autoComplete="username email"
              fieldClassName="mt-14"
              props={{ testId: 'email-input' }}
            />
            <Field
              name="password"
              isBackgroundErrorDisplay={false}
              component={PasswordField}
              fieldClassName="mt-7"
              props={{
                autoComplete: 'current-password',
                testId: 'password-input',
              }}
            />
            <div style={{ textAlign: 'right' }}>
              <Link
                className="form-link mt-2"
                to={ROUTES.FORGOT_PASSWORD}
                data-testid="forgot-password-link"
              >
                Forgot password?
              </Link>
            </div>
          </FormTile.Body>
          <FormTile.Footer>
            {error && submitFailed && (
              <div
                className="form-tile-footer__error"
                data-testid="error-message"
              >
                {error}
              </div>
            )}
            <div className="form-tile-footer__panel">
              <Link to={ROUTES.SIGN_UP} className="text-decoration-none">
                <Button
                  className="_simple-red"
                  type="button"
                  dataTestId="sign-up"
                >
                  Sign Up
                </Button>
              </Link>
              <Button className="_red" type="submit" dataTestId="sign-in">
                Sign In
              </Button>
            </div>
          </FormTile.Footer>
        </FormTile>
      </form>
    );
  }
}
